import { ORDER_STATES, ENT_RENT_ORDER_STATES } from '@/pages/orders/orderRenewal/config'
import { RENT_CATEGORY, RELATED_TYPE_LIST, PAYMENT_MODE_LIST } from '@/pages/orders/orderRenewal/add/config/originOrderInfo'
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'

export const personalOrderInfoMixin = {
  data() {
    return {
      orderSearchType: 'carId', // carId: 车牌号 customerId: 客户名称
      orderSearchConfig: {
        list: [
          {
            el: 'select',
            itemConfig: {
              label: '车牌号',
              prop: 'carId',
            },
            elConfig: {
              filterable: true,
              remote: true,
              reserveKeyword: true,
              clearable: true,
              defaultFirstOption: false,
              popperAppendToBody: false,
              remoteMethod: this.gerCarList,
              loading: false,
              placeholder: '请输入',
              options: {
                label: 'plateNo',
                value: 'id',
                list: [],
              },
              slotRender: (createElement) => {
                const isEdge = /Edg/.test(navigator.userAgent) || /Edge/.test(navigator.userAgent)
                return createElement('el-button', {
                  slot: 'prefix',
                  props: {
                    type: 'text',
                  },
                  style: {
                    position: 'absolute',
                    left: isEdge ? '220px' : '190px',
                    top: '6px',
                    fontSize: '12px',
                  },
                  nativeOn: {
                    click: (e) => {
                      e.stopPropagation()
                      this.handelOrderQueryTypeToggle()
                    },
                  },
                }, ['切换客户名称'])
              },
            },
            isShow: true,
          },
          {
            el: 'select',
            itemConfig: {
              label: '客户名称',
              prop: 'customerId',
            },
            elConfig: {
              filterable: true,
              remote: true,
              reserveKeyword: true,
              clearable: true,
              defaultFirstOption: false,
              popperAppendToBody: false,
              jsxRender: (option) => {
                return <CustomerNameOptionItem data={option} />
              },
              remoteMethod: (query) => {
                this.getCustomerList(query)
              },
              loading: false,
              placeholder: '请输入',
              options: {
                label: 'customerName',
                value: 'id',
                list: [],
              },
              slotRender: (createElement) => {
                const isEdge = /Edg/.test(navigator.userAgent) || /Edge/.test(navigator.userAgent)
                return createElement('el-button', {
                  slot: 'prefix',
                  props: {
                    type: 'text',
                  },
                  style: {
                    position: 'absolute',
                    left: isEdge ? '220px' : '190px',
                    top: '6px',
                    fontSize: '12px',
                  },
                  nativeOn: {
                    click: (e) => {
                      e.stopPropagation()
                      this.handelOrderQueryTypeToggle()
                    },
                  },
                }, ['切换车牌号'])
              },
            },
            isShow: false,
          },
          {
            el: 'text',
            itemConfig: {
              label: '所属部门',
              prop: 'deptName',
            },
          },
          {
            el: 'select',
            itemConfig: {
              label: '订单ID',
              prop: 'orderId',
            },
            elConfig: {
              placeholder: '请选择订单ID',
              options: {
                label: 'label',
                value: 'value',
                list: [],
              },
            },
          },
        ],
        model: {
          carId: '', // 车牌号
          customerId: '', // 客户名称
          deptName: '', // 所属部门
          orderId: '', // 订单ID
        },
      },
      orderSearchTip: '请先输入原订单id或车牌号，查询原订单信息',
      orderInfo: {
        title: '原订单信息',
        list: [
          {
            el: 'text',
            itemConfig: {
              label: '订单ID',
              prop: 'id',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '订单类型',
              prop: 'type',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '订单状态',
              prop: 'state',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '订单创建时间',
              prop: 'gmtCreate',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '收款起止日期',
              prop: 'receivablePeriod',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '赠送天数',
              prop: 'presentDays',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '免租周期',
              prop: 'presentDate',
            },
          },
          {
            el: 'input',
            itemConfig: {
              label: '合同附件',
              prop: 'contractAttachment',
            },
            elConfig: {
              render: (createElement) => {
                return createElement('a', {
                  attrs: {
                    href: this.orderInfo.model.contractAttachment.url,
                    download: this.orderInfo.model.contractAttachment.name,
                  },
                  style: {
                    color: '#2e7eff',
                  },
                }, [this.orderInfo.model.contractAttachment.name])
              },
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '租金总金额',
              prop: 'totalAmount',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '押金总金额',
              prop: 'totalDeposit',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '租赁类别',
              prop: 'rentCategory',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '租金收款方式',
              prop: 'payMode',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '是否关联订单',
              prop: 'relatedOrder',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '关联原因',
              prop: 'relatedType',
            },
          },
        ],
        model: {
          id: '', // 订单ID
          type: '', // 订单类型
          state: '', // 订单状态
          gmtCreate: '', // 订单创建时间
          receivablePeriod: '', // 收款起止日期
          presentDays: '', // 赠送天数
          presentDate: '', // 免租周期 presentStartDate presentEntDate
          contractAttachment: { // 合同附件
            url: '',
            name: '',
          },
          totalAmount: '', // 租金总金额
          totalDeposit: '', // 押金总金额
          rentCategory: '', // 租赁类别
          payMode: '', // 租金收款方式
          relatedOrder: '', // 是否关联订单
          relatedType: '', // 关联原因
        },
      },
      entRentOrderInfo: null,
      carInfo: {
        list: [
          {
            el: 'text',
            itemConfig: {
              label: '车牌号',
              prop: 'plateNo',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '车辆ID',
              prop: 'carId',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '品牌',
              prop: 'brandName',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '车系',
              prop: 'brandName',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '车型',
              prop: 'modelName',
              width: 160,
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '车辆状态',
              prop: 'carState',
            },
          },
        ],
        model: {
          plateNo: '', // 车牌号
          carId: '', // 车辆ID
          brandName: '',
          seriesName: '',
          modelName: '', // 车型
          carState: '', // 车辆状态
        },
      },
      customerInfo: {
        list: [
          {
            el: 'text',
            itemConfig: {
              label: '客户类型',
              prop: 'customerType',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '客户名称',
              prop: 'customerName',
              width: 110,
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '联系电话',
              prop: 'tel',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '身份证号',
              prop: 'idCard',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '身份证有效期',
              prop: 'idCardValidDate',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '驾驶证有效期',
              prop: 'driverLicenceValidDate',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '网约车证有效期',
              prop: 'carTransportLicenseExpiryDate',
            },
          },
        ],
        model: {
          customerType: '', // 客户类型
          customerName: '', // 客户名称
          tel: '', // 联系电话
          idCard: '', // 身份证号
          idCardValidDate: '', // 身份证有效期
          driverLicenceValidDate: '', // 驾驶证有效期
          carTransportLicenseExpiryDate: '', // 网约车证有效期
        },
      },
    }
  },
}

export const enterpriseOrderInfoMixin = {
  data() {
    return {
      orderSearchType: 'customerId', // customerId: 客户名称
      orderSearchConfig: {
        list: [
          {
            el: 'select',
            itemConfig: {
              label: '客户名称',
              prop: 'customerId',
            },
            elConfig: {
              filterable: true,
              remote: true,
              reserveKeyword: true,
              clearable: true,
              defaultFirstOption: false,
              popperAppendToBody: false,
              remoteMethod: (query) => {
                this.getCustomerList(query)
              },
              loading: false,
              placeholder: '请输入',
              options: {
                label: 'customerName',
                value: 'id',
                list: [],
              },
            },
          },
          {
            el: 'select',
            itemConfig: {
              label: '主订单ID',
              prop: 'orderId',
            },
            elConfig: {
              placeholder: '请选择主订单ID',
              options: {
                label: 'label',
                value: 'value',
                list: [],
              },
            },
          },
        ],
        model: {
          customerId: '', // 客户名称
          deptName: '', // 所属部门
          orderId: '', // 订单ID
        },
      },
      orderSearchTip: '请先输入原订单id或客户姓名，查询原订单信息',
      orderInfo: {
        title: '原订单信息',
        list: [
          {
            el: 'text',
            itemConfig: {
              label: '订单ID',
              prop: 'id',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '订单类型',
              prop: 'type',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '订单状态',
              prop: 'state',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '客户名称',
              prop: 'customerName',
              width: 110,
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '客户ID',
              prop: 'customerId',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '订单创建时间',
              prop: 'gmtCreate',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '合同开始日期',
              prop: 'contractStartDate',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '合同结束日期',
              prop: 'contractEndDate',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '押金总金额',
              prop: 'deposit',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '一次性管理费',
              prop: 'manageFee',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '其他服务费',
              prop: 'serviceFee',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '业务合同编号',
              prop: 'contractNo',
            },
          },
          {
            el: 'input',
            itemConfig: {
              label: '备注',
              prop: 'remarks',
            },
            elConfig: {
              render: (createElement) => {
                return createElement('p', {
                  style: {
                    maxWidth: '218px',
                    margin: '0px',
                  },
                }, [this.orderInfo.model.remarks])
              },
            },
          },
          {
            el: 'input',
            itemConfig: {
              label: '合同附件',
              prop: 'contractAttachments',
            },
            elConfig: {
              render: (createElement) => {
                return createElement(
                  'p',
                  {
                    style: {
                      display: 'flex',
                      justifyContent: 'flex-start',
                      flexWrap: 'wrap',
                      maxWidth: '218px',
                      margin: '0',
                    },
                  },
                  this.orderInfo.model.contractAttachments.map((item) => {
                    return createElement('a', {
                      attrs: {
                        href: item.url,
                        download: item.name,
                      },
                      style: {
                        flex: 'none',
                        margin: '0 6px 0 0',
                        color: '#2e7eff',
                      },
                    }, [item.name])
                  }),
                )
              },
            },
          },
        ],
        model: {
          id: '', // 订单ID
          type: '', // 订单类型
          state: '', // 订单状态
          customerName: '', // 客户名称
          customerId: '', // 客户ID
          gmtCreate: '', // 订单创建时间
          contractStartDate: '', // 合同开始日期
          contractEndDate: '', // 合同结束日期
          deposit: '', // 押金总金额
          manageFee: '', // 一次性管理费
          serviceFee: '', // 其他服务费
          contractNo: '', // 业务合同编号
          remarks: '', // 备注
          contractAttachments: [], // 合同附件
        },
      },
      entRentOrderInfo: null,
      carInfo: null,
      customerInfo: null,
    }
  },
}

export const enterpriseSubOrderInfoMixin = {
  data() {
    return {
      orderSearchType: 'carId', // carId: 车牌号 customerId: 客户名称
      orderSearchConfig: {
        list: [
          {
            el: 'CarSelect',
            itemConfig: {
              label: '车牌号',
              prop: 'carId',
            },
            elConfig: {
              render: 'CarSelect',
              getCarDetail: false,
              events: {
                change: (val) => this.carIdChange(val),
              },
            },
            isShow: true,
          },
          {
            el: 'text',
            itemConfig: {
              label: '所属部门',
              prop: 'deptName',
            },
          },
          {
            el: 'select',
            itemConfig: {
              label: '订单ID',
              prop: 'orderId',
            },
            elConfig: {
              placeholder: '请选择订单ID',
              options: {
                label: 'label',
                value: 'value',
                list: [],
              },
            },
          },
        ],
        model: {
          carId: '', // 车牌号
          deptName: '', // 所属部门
          orderId: '', // 订单ID
        },
      },
      orderSearchTip: '请先输入原订单id或车牌号，查询原订单信息',
      orderInfo: {
        title: '原子订单信息',
        list: [
          {
            el: 'text',
            itemConfig: {
              label: '订单ID',
              prop: 'id',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '订单类型',
              prop: 'type',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '订单状态',
              prop: 'state',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '订单创建时间',
              prop: 'gmtCreate',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '收款起止日期',
              prop: 'receivablePeriod',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '赠送天数',
              prop: 'presentDays',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '免租周期',
              prop: 'presentDate',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '租金收款方式',
              prop: 'payMode',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '租金总金额',
              prop: 'totalAmount',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '押金总金额',
              prop: 'totalDeposit',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '租赁类别',
              prop: 'rentCategory',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '是否关联订单',
              prop: 'relatedOrder',
            },
            isShow: false,
          },
          {
            el: 'text',
            itemConfig: {
              label: '关联原因',
              prop: 'relatedType',
            },
          },
        ],
        model: {
          id: '', // 订单ID
          type: '', // 订单类型
          state: '', // 订单状态
          gmtCreate: '', // 订单创建时间
          receivablePeriod: '', // 收款起止日期
          presentDays: '', // 赠送天数
          presentDate: '', // 免租周期 presentStartDate presentEntDate
          totalAmount: '', // 租金总金额
          totalDeposit: '', // 押金总金额
          rentCategory: '', // 租赁类别
          payMode: '', // 租金收款方式
          relatedOrder: '', // 是否关联订单
          relatedType: '', // 关联原因
        },
      },
      entRentOrderInfo: {
        title: '企业租赁主订单信息',
        list: [
          {
            el: 'text',
            itemConfig: {
              label: '企业租赁主订单ID',
              prop: 'id',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '企业租赁主订单状态',
              prop: 'state',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '合同开始日期',
              prop: 'contractStartDate',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '合同结束日期',
              prop: 'contractEndDate',
            },
          },
        ],
        model: {
          id: '', // 企业租赁主订单ID
          state: '', // 企业租赁主订单状态
          contractStartDate: '', // 合同开始日期
          contractEndDate: '', // 合同结束日期
        },
      },
      carInfo: {
        list: [
          {
            el: 'text',
            itemConfig: {
              label: '车牌号',
              prop: 'plateNo',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '车辆ID',
              prop: 'carId',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '品牌',
              prop: 'brandName',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '车系',
              prop: 'seriesName',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '车型',
              prop: 'modelName',
              width: 160,
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '车辆状态',
              prop: 'carState',
            },
          },
        ],
        model: {
          plateNo: '', // 车牌号
          carId: '', // 车辆ID
          brandName: '', // 品牌
          seriesName: '',
          modelName: '', // 车型
          carState: '', // 车辆状态
        },
      },
      customerInfo: {
        list: [
          {
            el: 'text',
            itemConfig: {
              label: '客户类型',
              prop: 'customerType',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '客户名称',
              prop: 'customerName',
              width: 110,
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '联系电话',
              prop: 'tel',
            },
          },
        ],
        model: {
          customerType: '', // 客户类型
          customerName: '', // 客户名称
          tel: '', // 联系电话
        },
      },
    }
  },
}

export function getOrderInfoMixinByOrderType(type) {
  if (type === 'personal') {
    return personalOrderInfoMixin
  } else if (type === 'enterprise') {
    return enterpriseOrderInfoMixin
  } else if (type === 'enterpriseSub') {
    return enterpriseSubOrderInfoMixin
  }
}

export function backfillPersonalOrderInfo(data) {
  let contractAttachment
  try {
    contractAttachment = JSON.parse(data.contractUrl || '[]')[0] || {}
  } catch (err) {
    contractAttachment = {}
  }

  const orderInfoModel = {
    // 订单ID
    id: data.id || '',
    // 订单类型
    type: '个人订单',
    // 订单状态
    state: (Object.values(ORDER_STATES).find((item) => item.value === data.state) || {}).name || '',
    // 订单创建时间
    gmtCreate: data.gmtCreate || '',
    // 收款起止日期
    receivablePeriod: data.receivablePeriod || '',
    // 赠送天数
    presentDays: (data.presentDays || '') + (data.presentDays ? '日' : ''),
    // 免租周期
    presentDate: data.presentStartDate && data.presentEntDate ? `${data.presentStartDate} ~ ${data.presentEntDate}` : '',
    // 租金总金额
    totalAmount: (data.totalAmount || '') + (data.totalAmount && !String(data.totalAmount).endsWith('元') ? '元' : ''),
    // 押金总金额
    totalDeposit: (data.totalDeposit || '') + (data.totalDeposit ? '元' : ''),
    // 租赁类别
    rentCategory: (Object.values(RENT_CATEGORY).find((item) => item.value === data.rentCategory) || {}).name || '',
    // 租金收款方式
    payMode: (PAYMENT_MODE_LIST.find((item) => item.value === data.payMode) || {}).name || '',
    // 是否关联订单
    relatedOrder: data.relatedOrderId ? '是' : '否',
    // 关联原因
    relatedType: (RELATED_TYPE_LIST.find((item) => item.value === data.relatedType) || {}).name || '',
    // 合同附件
    contractAttachment,
  }
  const carInfoModel = {
    // 车牌号
    plateNo: data.plateNo || '',
    // 车辆ID
    carId: data.carId || '',
    brandName: data.brandName || '',
    seriesName: data.seriesName || '',
    // 车型
    modelName: data.modelName || '',
    // 车辆状态
    carState: data.carState || '',
  }
  const customerInfoModel = {
    // 客户类型
    customerType: data.customerType === 1 ? '个人' : '企业',
    // 客户名称
    customerName: data.customerName || '',
    // 联系电话
    tel: data.tel || '',
    // 身份证号
    idCard: data.idCard || '',
    // 身份证有效期
    idCardValidDate: data.idCardValidDate || '',
    // 驾驶证有效期
    driverLicenceValidDate: data.driverLicenceValidDate || '',
    // 网约车证有效期
    carTransportLicenseExpiryDate: data.carTransportLicenseExpiryDate || '',
  }


  this.orderInfo.model = orderInfoModel
  this.carInfo.model = carInfoModel
  this.customerInfo.model = customerInfoModel
}

export function backfillEnterpriseOrderInfo(data) {
  const contractAttachments = data.contractAttachment || []

  const orderInfoModel = {
    // 订单ID
    id: data.id || '',
    // 订单类型
    type: '企业订单',
    // 订单状态
    state: (Object.values(ENT_RENT_ORDER_STATES).find((item) => item.value === data.state) || {}).name || '',
    // 客户名称
    customerName: data.customerName || '',
    // 客户ID
    customerId: data.customerId || '',
    // 订单创建时间
    gmtCreate: data.gmtCreate || '',
    // 合同开始日期
    contractStartDate: data.contractStartDate || '',
    // 合同结束日期
    contractEndDate: data.contractEndDate || '',
    // 押金总金额
    deposit: (data.deposit || '') + (data.deposit ? '元' : ''),
    // 一次性管理费
    manageFee: (data.manageFee || '') + (data.manageFee ? '元' : ''),
    // 其他服务费
    serviceFee: (data.serviceFee || '') + (data.serviceFee ? '元' : ''),
    // 业务合同编号
    contractNo: data.contractNo || '',
    // 备注
    remarks: data.remarks || '',
    // 合同附件
    contractAttachments,
  }

  this.orderInfo.model = orderInfoModel
}

export function backfillEnterpriseSubOrderInfo(data) {
  const orderInfoModel = {
    // 订单ID
    id: data.id || '',
    // 订单类型
    type: '企业订单',
    // 订单状态
    state: (Object.values(ORDER_STATES).find((item) => item.value === data.state) || {}).name || '',
    // 订单创建时间
    gmtCreate: data.gmtCreate || '',
    // 收款起止日期
    receivablePeriod: data.receivablePeriod || '',
    // 赠送天数
    presentDays: (data.presentDays || '') + (data.presentDays ? '日' : ''),
    // 免租周期
    presentDate: data.presentStartDate && data.presentEntDate ? `${data.presentStartDate} ~ ${data.presentEntDate}` : '',
    // 租金总金额
    totalAmount: (data.totalAmount || '') + (data.totalAmount ? '元' : ''),
    // 押金总金额
    totalDeposit: (data.totalDeposit || '') + (data.totalDeposit ? '元' : ''),
    // 租赁类别
    rentCategory: (Object.values(RENT_CATEGORY).find((item) => item.value === data.rentCategory) || {}).name || '',
    // 租金收款方式
    payMode: (PAYMENT_MODE_LIST.find((item) => item.value === data.payMode) || {}).name || '',
    // 是否关联订单
    relatedOrder: data.relatedOrderId ? '是' : '否',
    // 关联原因
    relatedType: (RELATED_TYPE_LIST.find((item) => item.value === data.relatedType) || {}).name || '',
  }
  const carInfoModel = {
    // 车牌号
    plateNo: data.plateNo || '',
    // 车辆ID
    carId: data.carId || '',
    brandName: data.brandName || '',
    seriesName: data.seriesName || '',
    // 车型
    modelName: data.modelName || '',
    // 车辆状态
    carState: data.carState || '',
  }
  const customerInfoModel = {
    // 客户类型
    customerType: data.customerType === 1 ? '个人' : '企业',
    // 客户名称
    customerName: data.customerName || '',
    // 联系电话
    tel: data.tel || '',
  }

  this.orderInfo.model = orderInfoModel
  this.carInfo.model = carInfoModel
  this.customerInfo.model = customerInfoModel
}

export function backfillEnterpriseSubEntRentOrderInfo(data) {
  const entRentOrderInfoModel = {
    // 企业租赁主订单ID
    id: data.id || '',
    // 企业租赁主订单状态
    state: (Object.values(ENT_RENT_ORDER_STATES).find((item) => item.value === data.state) || {}).name || '',
    // 合同开始日期
    contractStartDate: data.contractStartDate || '',
    // 合同结束日期
    contractEndDate: data.contractEndDate || '',
  }

  this.entRentOrderInfo.model = entRentOrderInfoModel
}
